import { useEffect } from 'react';
import { injectGlobalStyles } from "./styles";
injectGlobalStyles();
var useLockBodyScroll = function useLockBodyScroll(_ref) {
  var lockScroll = _ref.lockScroll,
    openBool = _ref.openBool;
  useEffect(function () {
    var body = document.body;
    if (!lockScroll) return;
    if (openBool) {
      if (body.hasAttribute('data-moly-lock-scroll')) {
        var lockCount = body.getAttribute('data-moly-lock-scroll') || '0';
        var newLock = parseInt(lockCount, 10) + 1 + '';
        body.setAttribute('data-moly-lock-scroll', newLock);
      } else {
        body.setAttribute('data-moly-lock-scroll', '1');
      }
    } else {
      if (body.hasAttribute('data-moly-lock-scroll')) {
        var _lockCount = body.getAttribute('data-moly-lock-scroll');
        if (_lockCount) {
          var _newLock = parseInt(_lockCount, 10) - 1;
          if (_newLock <= 0) {
            body.removeAttribute('data-moly-lock-scroll');
          } else {
            body.setAttribute('data-moly-lock-scroll', _newLock === null || _newLock === void 0 ? void 0 : _newLock.toString());
          }
        }
      }
    }
  }, [openBool, lockScroll]);
  useEffect(function () {
    return function () {
      var body = document.body;
      if (lockScroll) {
        if (body.hasAttribute('data-moly-lock-scroll')) {
          var lockCount = body.getAttribute('data-moly-lock-scroll');
          if (lockCount) {
            var newLock = parseInt(lockCount, 10) - 1;
            if (newLock <= 0) {
              body.removeAttribute('data-moly-lock-scroll');
            } else {
              body.setAttribute('data-moly-lock-scroll', newLock === null || newLock === void 0 ? void 0 : newLock.toString());
            }
          }
        }
      }
    };
  }, [lockScroll]);
  return {};
};
export default useLockBodyScroll;